export const GET_CONFIG_FAILURE = 'get-config-failure';
export const NAV_RENDER_FAILURE = 'nav-render-failure';
export const NAV_RENDERED_FROM_LOCAL_STORAGE = 'nav-rendered-from-local-storage';
export const GET_HUBLESS_CONFIG_FAILURE = 'get-hubless-config-failure';
export const INACCURATE_NAV_CONFIG_RESPONSE = 'inaccurate-nav-config-response';
export const VERTICAL_NAV_LOADED = 'vertical-nav-loaded';
export const VERTICAL_NAV_RENDERED = 'vertical-nav-rendered';
export const HEADLESS_NAV_RENDERED = 'headless-nav-rendered';
export const DEFAULT_TRANSLATION_USED = 'default-translation-used';
export const OVERLAY_MESSAGE_RECEIVED = 'overlay-message-received';
export const PUBLIC_API_USED = 'public-api-used';
export const PUBLIC_API_METHODS = {
  CHANGE_NAV_VISIBILITY: 'change-nav-visibility',
  GET_NAV_VISIBILITY: 'get-nav-visibility',
  INVALIDATE_NAV_CONFIG: 'invalidate-nav-config',
  GET_CURRENT_BOOKMARKS: 'get-current-bookmarks',
  ADD_BOOKMARK: 'add-bookmark',
  REMOVE_BOOKMARK: 'remove-bookmark'
};